import React from 'react';

function ContactEdit({ color = '#335B70', ...props }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2 12C2 6.48 6.48 2 12 2c4.247 0 7.878 2.652 9.327 6.389a2.688 2.688 0 00-1.577.77l-.97.97-.062-.063-3.448 3.448C14.13 13.11 12.873 12.9 12 12.9c-2 0-5.97 1.09-6 3.08a7.226 7.226 0 003.897 2.907l-.529.529v2.234C5.124 20.494 2 16.61 2 12zm13.925 9.2a9.96 9.96 0 01-4.557.78v-1.736l1.057-1.056A7.204 7.204 0 0018 15.98c-.009-.575-.347-1.075-.872-1.495l1.59-1.59 2.639 2.639c-.05.132-.102.262-.157.39L15.925 21.2zm5.948-10.798a10.059 10.059 0 01-.066 3.564l-2.017-2.018 1.374-1.374a.698.698 0 01.709-.172zM15 8c0-1.66-1.34-3-3-3S9 6.34 9 8s1.34 3 3 3 3-1.34 3-3z"
                fill={color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.474 15.65l-2.756-2.755-7.35 7.349V23h2.756l7.35-7.35zm2.32-2.446a.699.699 0 000-.989l-1.64-1.641a.699.699 0 00-.99 0l-1.375 1.374 2.63 2.63 1.376-1.374z"
                fill={color}
            />
        </svg>
    );
}

export default ContactEdit;
